import { call, put, takeLatest } from 'redux-saga/effects';
import { PayloadAction } from '@reduxjs/toolkit';

import { getHasMorePending, setHasMorePending, setHasMorePendingStatus } from '../actions/commentsActions';
import count from '../../api/count';
import { Folder, GetHasMorePendingRequest, GetHasMorePendingResponse } from '../types';

export function* getHasMorePendingSaga(action: PayloadAction<GetHasMorePendingRequest>) {
  const { spotId, pageInfo } = action.payload;
  const { tag, published, messageType } = pageInfo;
  const filters = { tag: tag.join(','), published, message_type: messageType };

  yield put(setHasMorePendingStatus('loading'));

  try {
    const response: GetHasMorePendingResponse = yield call(count, {
      folder: Folder.PENDING,
      spotId,
      filters
    });

    const {
      total_items: { pending }
    } = response;

    yield put(setHasMorePending(pending > 0));
    yield put(setHasMorePendingStatus('success'));
  } catch (error) {}
}

export function* commentsSagas() {
  yield takeLatest(getHasMorePending, getHasMorePendingSaga);
}
